import { createContext, useCallback, useMemo, useState } from "react";
import { CartItem } from "../clothing.types";

export interface CartContextType {
  items: CartItem[];
  cartIds: Set<CartItem["id"]>;
  addToCart: (item: CartItem) => void;
  removeFromCart: (id: CartItem["id"]) => void;
  isInCart: (id: CartItem["id"]) => boolean;
  totalItems: number;
  totalPrice: number;
}

export const CartContext = createContext<CartContextType | null>(null);

const CartProvider = ({ children }: { children: React.ReactNode }) => {
  const [items, setItems] = useState<CartItem[]>([]);
  const [cartIds, setCartIds] = useState<Set<CartItem["id"]>>(new Set());

  const addToCart = useCallback((item: CartItem) => {
    // ONLY ONE
    setItems([item]);

    /**  setItems((prev) => {
      const existing = prev.find((i) => i.id === item.id);
      if (existing) {
        return prev.map((i) =>
          i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i,
        );
      }
      return [...prev, { ...item, quantity: 1 }];
    }); 
    setCartIds((prev) => new Set(prev).add(item.id));
    
    */

    // ONLY ONE
    setCartIds(new Set([item.id]));
  }, []);

  const removeFromCart = useCallback((id: number) => {
    setItems((prev) => prev.filter((i) => i.id !== id));

    setCartIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, []);

  // O(1) lookup
  const isInCart = useCallback((id: number) => cartIds.has(id), [cartIds]);

  const totalItems = useMemo(
    () => items.reduce((sum, i) => sum + i.quantity, 0),
    [items],
  );

  const totalPrice = useMemo(
    () => items.reduce((sum, i) => sum + i.price * i.quantity, 0),
    [items],
  );

  const value = useMemo<CartContextType>(
    () => ({
      items,
      cartIds,
      addToCart,
      removeFromCart,
      isInCart,
      totalItems,
      totalPrice,
    }),
    [
      items,
      cartIds,
      addToCart,
      removeFromCart,
      isInCart,
      totalItems,
      totalPrice,
    ],
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export default CartProvider;
